// packages
import { Fragment } from 'react'
import { X, Check, FileImage, FileVideo, FileAudio, FileText, FileSpreadsheet } from 'lucide-react'

// components
import { Button } from '@/components/ui/button'

// constants
import { FILE_TYPES } from '@/constants/files'

// types
type FileProps = {
  file?: File
  name?: string
  base64?: string
  extension?: string
  url?: string
}
type FileListProps = {
  files: File[] | FileProps[] | null
  uploaded: boolean
  onRemove: (index: number) => void
}

export function FileList({ files, uploaded, onRemove }: FileListProps) {
  const IconFile = ({ extension }: { extension: string }) => {
    return (
      <>
        {FILE_TYPES.IMAGE?.includes(extension) && <FileImage className="h-4 w-4 text-primary" />}
        {FILE_TYPES.VIDEO?.includes(extension) && <FileVideo className="h-4 w-4 text-primary" />}
        {FILE_TYPES.AUDIO?.includes(extension) && <FileAudio className="h-4 w-4 text-primary" />}
        {FILE_TYPES.PDF?.includes(extension) && <FileText className="h-4 w-4 text-primary" />}
        {(FILE_TYPES.SPREADSHEET?.some(spd => spd.includes(extension)) || extension.includes('spreadsheet')) && <FileSpreadsheet className="h-4 w-4 text-primary" />}
      </>
    )
  }

  return (
    <div className="space-y-2 max-h-[400px] overflow-y-auto">
      {files?.map((file, index) => (
        <Fragment key={index}>
          {file instanceof File || file?.file instanceof File ? (
            <div className="flex items-center justify-between p-2 bg-primary/30 rounded-md">
              <div className="flex items-center space-x-2">
                <IconFile extension={file?.type?.split('/')[1] || file?.file?.type?.split('/')[1]} />
                <span className="text-md truncate max-w-[300px]">{file?.name || file?.file?.name}</span>
                <span className="text-sm text-muted-foreground">({file?.file ? (file?.file?.size / 1024)?.toFixed(1) : (file?.size / 1024)?.toFixed(1)} KB)</span>
              </div>
              {!uploaded && (
                <Button type="button" variant="ghost" size="sm" onClick={() => onRemove(index)} className="h-8 w-8 p-0 hover:bg-red-700/30">
                  <X className="h-4 w-4 text-white" />
                </Button>
              )}
            </div>
          ) : (
            !!file?.url && (
              <div className="flex items-center justify-between p-2 bg-primary/30 rounded-md">
                <div className="flex items-center space-x-2">
                  <Check className="h-4 w-4 text-gray-500" />
                  <span className="text-sm truncate max-w-[300px]">{file?.url?.split('/')?.at(-1)?.substring(37)?.replace('%20', ' ')}</span>
                </div>
                {!uploaded && (
                  <Button type="button" variant="ghost" size="sm" onClick={() => onRemove(index)} className="h-8 w-8 p-0">
                    <X className="h-4 w-4 text-white" />
                  </Button>
                )}
              </div>
            )
          )}
        </Fragment>
      ))}
    </div>
  )
}
